module.exports = require("@material-ui/icons/FolderOpen");